package one.healthium.settings.ui.meal_plan

import androidx.compose.ui.util.fastForEach
import loco.SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION
import loco.SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION
import one.healthium.loco.asLString
import one.healthium.meal_plans.domain.MealPlanInfoModel
import androidx.compose.runtime.Immutable

@Immutable
internal data class MealPlanSettingsUiState(
    val loading: Boolean = false,
    val currentMealPlan: MealPlanInfoModel? = null,
    val mealPlans: List<MealPlanInfoModel>? = null,
) {
    val uiData: List<Any>? = if (mealPlans != null) {

        buildList {
            val personalPlan = mealPlans.firstOrNull { it.id == MealPlanInfoModel.PERSONAL_ID }
            if (personalPlan != null) {
                add(loco.Res.string.SETTINGS_MEAL_PLAN_SETTINGS_PERSONAL_SECTION.asLString())
                add(personalPlan.toUiModel(checked = personalPlan.id == currentMealPlan?.id))
                add(loco.Res.string.SETTINGS_MEAL_PLAN_SETTINGS_OTHER_SECTION.asLString())
            }

            mealPlans.fastForEach { mealPlan ->
                if (mealPlan != personalPlan) {
                    add(mealPlan.toUiModel(checked = mealPlan.id == currentMealPlan?.id))
                }
            }
        }
    } else {
        null
    }
}

private fun MealPlanInfoModel.toUiModel(checked: Boolean) = MealPlanUiModel(
    id = id,
    name = name,
    checked = checked,
)
